import React from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";

MultiExpSessionStartModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleFilterValue: PropTypes.func.isRequired,
    monoShipmentCount: PropTypes.number.isRequired,
    multiShipmentCount: PropTypes.number.isRequired
};

/* FilterValue
    1 => For shipments containing only 1 item.
    2 => For shipments container 2 or more items.
 */

function MultiExpSessionStartModal({open, handleClose, handleFilterValue, multiShipmentCount, monoShipmentCount}) {
    return (
        <Popup
            open={open}
            onClose={() => handleClose()}
            title={<FormattedMessage id={"wms.packing.modal.multiExpSession.startModal.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.multiExpSession.startModal.subtitle"}/>}
            isMobile
        >
            <Grid
                container
                direction={"column"}
                gap={"16px"}
            >
                <CustomButton
                    onClick={() => handleFilterValue(1)}
                    fullWidth
                    disabled={monoShipmentCount === 0}
                >
                    <FormattedMessage id={"wms.packing.modal.multiExpSession.startModal.monoFilter"}/>
                </CustomButton>
                <CustomButton
                    onClick={() => handleFilterValue(2)}
                    fullWidth
                    disabled={multiShipmentCount === 0}
                >
                    <FormattedMessage id={"wms.packing.modal.multiExpSession.startModal.multiFilter"}/>
                </CustomButton>
            </Grid>
        </Popup>
    );
}

export default MultiExpSessionStartModal;